const en = {
	common: require("@locales/en/common.json"),
	header: require("@locales/en/header.json"),
	"home-page": require("@locales/en/home-page.json"),
};

const de = {
	common: {},
	header: {},
};

module.exports = {
	en,
	de,
};
